import { Output, Component, Input, EventEmitter } from "@angular/core";
import { EButtonType } from "../../../data-types/button.enum";
import { iconsLibrary } from "../../../../theme/constants";
import { ISpace } from "../../../data-types/space.interface";
import { CoworkingService } from "../../../services/coworking.service";
import { IAppState } from "../../../store/state/app.state";
import { Store } from "@ngrx/store";
import { showAlertAction } from "../../../store/actions/alert.action";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "cowing-card",
  templateUrl: "./cowing-card.component.html",
  styleUrls: ["./cowing-card.component.scss"],
})
export class CowingCardComponent {
  @Input("space") space: any;

  constructor(
    private _store: Store<IAppState>,
    private _translate: TranslateService
  ) {}

  iconsLibrary;
  onPause() {
    if (this.space.status === 0) {
      this._store.dispatch(
        showAlertAction({
          payload: {
            message: this._translate.instant(
              "coworking-home.spaces.activate-message"
            ),
            title: this._translate.instant(
              "coworking-home.spaces.activate-title"
            ),
            type: "pause",
            spaceId: this.space.id,
          },
        })
      );
    } else {
      this._store.dispatch(
        showAlertAction({
          payload: {
            message: this._translate.instant(
              "coworking-home.spaces.pause-message"
            ),
            title: this._translate.instant("coworking-home.spaces.pause-title"),
            type: "reactivate",
            spaceId: this.space.id,
          },
        })
      );
    }
  }

  public get getPauseIcon() {
    return `${iconsLibrary["pauseSvg"]}`;
  }
}
